import $ from 'jquery';
import {onResize} from "../utils/window";


export default function homepage() {
	const $html = $('html');
	const $scroller = $('html, body');
	const homepage = $('.homepage');

	if (homepage.length) {
		const homepageNews = homepage.find('.homepage-news');
		const homepageNewsBg = homepageNews.find('.homepage-news_bg');
		const media = homepageNews.find('.grid .cell:first-child .card_media');
		const title = homepageNews.find('.homepage-news_title h5');

		function setupHeight(media, title, homepageNews, homepageNewsBg) {
			let totalPadding = media.outerHeight() + title.outerHeight() + parseInt(title.css('margin-bottom')) + parseInt(homepageNews.css('padding-top'));
			homepageNewsBg.css('height', totalPadding + 'px');
		}

		setupHeight(media, title, homepageNews, homepageNewsBg);

		onResize(function() {
			setupHeight(media, title, homepageNews, homepageNewsBg);
		});
	}
}



// WEBPACK FOOTER //
// ./source/scripts/pages/homepage.js